<template>
  <div class="card-container">
    <div class="card" :class="{ 'critical-card': cardData.중점대상여부 }" v-for="(cardData, _card_i) in parsedListProcessed" :key="`mobile_list_${_card_i}`">
      <div class="card-header">
        <div class="card-number status-badge">{{ cardData.No }}</div>
        <div class="card-title">{{ cardData.작업내용 }}</div>
      </div>

      <div class="info-grid">
        <div class="info-item">
          <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
          <span class="info-label">부서명:</span>
          <span class="info-value">{{ cardData.부서명 }}</span>
        </div>

        <div class="info-item">
          <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span class="info-label">상태:</span>
          <span class="status-badge" :style="{ backgroundColor: cardData.상태.color }">{{ cardData.상태.text }}</span>
        </div>

        <div class="info-item">
          <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span class="info-label">작업장소:</span>
          <span class="info-value">{{ cardData.작업장소 }}</span>
        </div>

        <div class="info-item">
          <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span class="info-label">작업시작일:</span>
          <span class="info-value">{{ cardData.작업시작일 }}</span>
        </div>
      </div>

      <div class="section-divider"></div>

      <div class="badge-section">
        <span class="info-badge" :class="{ 'success': cardData.TBM완료여부, 'danger': !cardData.TBM완료여부 }">
          TBM {{ cardData.TBM완료여부 ? '완료' : '미진행' }}
        </span>
        <span class="info-badge" :class="{ 'success': cardData.안환팀확인여부, 'danger': !cardData.안환팀확인여부 }">
          안환팀 {{ cardData.안환팀확인여부 ? '확인' : '미확인' }}
        </span>
        <span v-if="cardData.중점대상여부" class="info-badge critical">
          중점대상
        </span>
      </div>

      <button class="action-button" @click="() => onClickDetail(cardData)">
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        내용 보기
      </button>
    </div>
    <slot name="empty"></slot>
    <slot name="pagenation"></slot>
  </div>
</template>

<script>
export default {
  props: {
    parsedListForTable: {
      type: Array,
      required: true,
    },
  },
  computed: {
    parsedListProcessed() {
      return this.parsedListForTable.map((item) => {
        const newItem = { ...item };

        // 모든 키에 대해 <br> 태그 제거
        Object.keys(newItem).forEach((key) => {
          const cleanedKey = key.replace(/<br\s*\/?>/gi, "");
          if (cleanedKey !== key) {
            newItem[cleanedKey] = newItem[key];
            delete newItem[key];
          }
        });

        // 작업유형 문자열 -> 배열로 변환
        if (typeof newItem["작업유형"] === "string") {
          newItem["작업유형"] = newItem["작업유형"]
            .split(",")
            .map((v) => v.trim())
            .filter(Boolean);
        }

        // 중점대상 판단
        const 중점대상항목 = ['고소', '중장비', '밀폐', '방사선', '굴착'];
        const 작업유형배열 = Array.isArray(newItem["작업유형"]) ? newItem["작업유형"] : [];
        newItem["중점대상여부"] = 작업유형배열.some(item => 중점대상항목.some(keyword => item.includes(keyword)));

        // TBM 여부 텍스트를 boolean으로 변환
        const tbmHtml = newItem["TBM 여부"] && newItem["TBM 여부"].html;
        newItem["TBM완료여부"] = tbmHtml && tbmHtml.includes("완료");

        // 안환팀 확인 여부를 boolean으로 변환
        const 안환팀확인 = newItem["확인(안환팀)"];
        newItem["안환팀확인여부"] = 안환팀확인 && 안환팀확인.toUpperCase() === "Y";

        return newItem;
      });
    },
  },
  methods: {
    onClickDetail(item, target = "self") {
      this.$emit("selected", item, target);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-container {
  margin: 0 auto;
  border-radius: 12px;
  padding: 1rem;
}

.card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 24px;
  margin-bottom: 20px;
  position: relative;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.card-number {
  background: #6670cb;
  color: white;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  margin-right: 12px;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  color: #374151;
  line-height: 1.4;
}

.info-grid {
  display: grid;
  gap: 16px;
  background-color: #f3f4f6;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 0;
}

.section-divider {
  height: 1px;
  background: #e5e7eb;
  margin-bottom: 20px;
}

.info-item {
  display: flex;
  align-items: center;
}

.info-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  flex-shrink: 0;
}

.info-label {
  font-size: 13px;
  color: #6b7280;
  margin-right: 8px;
  min-width: 80px;
}

.info-value {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.status-badge {
  background: #6670cb;
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.badge-section {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.info-badge {
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;

  &.success {
    background: #dcfce7;
    color: #166534;
    border-color: #bbf7d0;
  }

  &.danger {
    background: #fef2f2;
    color: #991b1b;
    border-color: #fecaca;
  }

  &.critical {
    background: #ef4444;
    color: white;
    border-color: #dc2626;
  }
}

.critical-card {
  border: 2px solid #fecaca;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.15);
}

.action-button {
  background: #10b981;
  color: white;
  border: none;
  padding: 14px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
</style>
